import Child from "./Child";
import Count from "./Count";
import { $t } from "../i18n";

export default class Item {
    constructor(adults, category, listIndex, config) {
        this._type = '';
        this._category = category || '';
        this._subitem = '';
        this._adults = adults;
        this._bikes = 0;
        this._counts = [];
        this._children = [];
        this._errors = {};
        this._config = config || null;
        this._active = false;
        this._listIndex = listIndex;
    }

    get subitem() {
        return this._subitem;
    }

    set subitem(subitem) {
        this._subitem = subitem;
    }

    get listIndex() {
        return this._listIndex;
    }

    set listIndex(listIndex) {
        this._listIndex = parseInt(listIndex);
    }

    get active() {
        return this._active;
    }

    set active(active) {
        this._active = active;
    }

    get adults() {
        return this._adults;
    }

    set adults(adults) {
        this._adults = parseInt(adults);
    }

    get children() {
        return this._children;
    }

    get numberOfChildren() {
        return this._children.length;
    }

    get childAge() {
        let childAge = '';
        for (let j = 0; j < this.children.length; j++) {
            childAge += this.children[j].age;
            if (j < this.children.length - 1) {
                childAge += ',';
            }
        }
        return childAge;
    }

    get errors() {
        return this._errors;
    }

    valid() {
        return Object.values(this._errors).every(e => !e)
    }

    invalid() {
        return Object.values(this._errors).some(e => e)
    }

    validate(step) {
        if (this._category === '') {
            this._errors.category = true;
        } else {
            this._errors.category = false;
        }
        if (typeof step.categories[this.listIndex].subitems !== 'undefined') {
            if (this._subitem === '') {
                this._errors.subitem = true;
            } else {
                this._errors.subitem = false;
            }
        }
        return this.valid();
    }

    addChild() {
        const newChild = new Child();
        this._children.push(newChild);
        return newChild;
    }

    removeChild(index) {
        if (typeof index === 'undefined') {
            this._children.pop()
        } else {
            this._children.splice(index, 1);
        }
    }

    setChildrenCount(newCount) {
        if (newCount === this._children.length) {
            return
        }

        if (newCount > this._children.length) {
            const missingChildCount = newCount - this._children.length
            for (let i = 0; i < missingChildCount; i++) {
                this.addChild()
            }
            return
        }

        const surplusChildCount = this._children.length - newCount
        for (let i = 0; i < surplusChildCount; i++) {
            this.removeChild()
        }
    }

    get counts() {
        return this._counts;
    }

    addCount(label) {
        if (this.counts.find(c => c.label === label)) {
            // ignore existing labels
            return;
        }
        const newCount = new Count(label);
        this._counts.push(newCount);
        return newCount;
    }

    getChildByIndex(index) {
        return this._children[index];
    }

    get type() {
        return this._type;
    }

    get config() {
        return this._config;
    }

    get renderChildren() {
        if (this.config) {
            if (typeof this.config.children !== 'undefined') {
                return this.config.children.render;
            }
        }
        return true;
    }

    get renderChildAge() {
        if (this.config) {
            if (typeof this.config.children !== 'undefined') {
                return this.config.children.age;
            }
        }
        return true;
    }

    get fieldName() {
        if (this.config) {
            if (typeof this.config.fieldname !== 'undefined') {
                return this.config.fieldname;
            }
        }
        return 'adults';
    }

    get personLabel() {
        if (this.config) {
            if (typeof this.config.fieldname !== 'undefined' && this.config.fieldname === 'individuals') {
                return $t('item.person.title', 2);
            }
        }
        return $t('item.person.adult', 2);
    }

    set type(type) {
        this._type = parseInt(type);
    }

    get category() {
        return this._category;
    }

    set category(category) {
        this._category = category;
    }

    fillDummyData(categories) {
        this._children = [];
        const rndChildCount = Math.floor(Math.random() * 4) + 1;
        for (let i = 0; i < rndChildCount; i++) {
            const newChild = this.addChild();
            newChild.age = Math.floor(Math.random() * 17) + 1;
        }
        if (typeof categories[this.listIndex].subitems !== 'undefined') {
            const rndSubitemIndex = Math.floor(Math.random() * categories[this.listIndex].subitems.length);
            this._subitem = categories[this.listIndex].subitems[rndSubitemIndex];
        }
    }


    adultStringDiverse() {
        switch (this.adults) {
            case 0:
                return null;
            case 1:
                return 'ein Erwachsener';
            default:
                return `${this.adults} Erwachsene`
        }
    }

    personStringDiverse() {
        switch (this.adults) {
            case 0:
                return null;
            case 1:
                return 'eine Person';
            default:
                return `${this.adults} Personen`
        }
    }

    descriptionDiverse() {
        let personString = this.adultStringDiverse();
        if (this.personLabel === 'Personen') {
            personString = this.personStringDiverse();
        }
        let suffix = [personString, this.numberOfChildrenString()].filter(function (el) {
            return el != null;
        }).join(' und ');
        if (this.bikes) {
            suffix += `(${this.bikes} Fahrräder)`;
        }
        for (let i = 0; i < this.counts.length; i++) {
            const count = this.counts[i];
            suffix += `<br>${count.label}: ${count.count}`
        }
        return suffix;
    }

    adultString() {
        switch (this.adults) {
            case 0:
                return null;
            case 1:
                return 'einen Erwachsenen';
            default:
                return `${this.adults} Erwachsene`
        }
    }

    numberOfChildrenString() {
        switch (this.numberOfChildren) {
            case 0:
                return null;
            case 1:
                return 'ein Kind';
            default:
                return `${this.numberOfChildren} Kinder`;
        }
    }

    description() {
        const suffix = [this.adultString(), this.numberOfChildrenString()].filter(function (el) {
            return el != null;
        }).join(' und ');
        return this.category + ' für ' + suffix;
    }
}

